import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import BalancoFinanc1 from '../imagens/RelBalancoFinanc/BalancoFinanc1.png';
import BalancoFinanc2 from '../imagens/RelBalancoFinanc/BalancoFinanc2.png';
import BalancoFinanc3 from '../imagens/RelBalancoFinanc/BalancoFinanc3.png';
import BalancoFinanc4 from '../imagens/RelBalancoFinanc/BalancoFinanc4.png';
import BalancoFinanc5 from '../imagens/RelBalancoFinanc/BalancoFinanc5.png';
import BalancoFinanc6 from '../imagens/RelBalancoFinanc/BalancoFinanc6.png';

export default class RelBalancoFinanc extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar o relatório de Balanço Financeiro"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o relatório de Balanço Financeiro:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={BalancoFinanc1} alt="Balanço 1"/>
                        </div>

                        <div className="gray_bar"></div>                      

                        <div className="image-wrapper">
                            <img src={BalancoFinanc2} alt="Balanço 1"/>
                        </div>

                        <h3>No relatório de Balanço Financeiro nós temos:</h3>
                        <ol>
                            <li>Filtros para definir o período e quais lançamentos que o Balanço está mostrando.</li>
                            <li>Abas onde é mostrado os lançamentos financeiros de forma detalhada.</li>
                            <li>Valor total dos lançamentos de entrada.</li>
                            <li>Valor total dos lançamentos de saída.</li>
                            <li>Valor total da diferença dos lançamentos de entrada e saída.</li>
                            <li>Valor total dos lançamentos a receber.</li>
                            <li>Valor total dos lançamentos a pagar.</li>
                            <li>Valor total da diferença entre os lançamentos a receber e a pagar.</li>
                            <li>Valor total dos lançamentos a receber vencidos.</li>
                            <li>Valor total dos lançamentos a pagar vencidos.</li>
                            <li>Valor total da diferença entre o valor dos lançamentos vencidos a receber e a pagar.</li>
                            <li>Entradas e saídas separados por conta financeira.</li>
                        </ol>

                        <div className="gray_bar"></div>    

                        <h3>Como definir o período considerado no Balanço Financeiro</h3>

                        <p>
                            Para definir qual o período que deve ser considerado para montar o balanço, basta acessar os filtros no botão "Filtrar". Fora o período,
                            você pode utilizar os outros filtros para filtrar ainda mais quais os lançamentos a serem considerados. Após escolher os filtros desejados basta 
                            clicar em "Filtrar".
                        </p>  
                        <div className="image-wrapper">
                            <img src={BalancoFinanc3} alt="Balanço 3"/>
                        </div>   
                        <div className="image-wrapper">
                            <img src={BalancoFinanc4} alt="Balanço 4"/>
                        </div>   

                        <div className="gray_bar"></div>      

                        <h3>Relatório detalhado dos lançamentos</h3>

                        <p>
                            Caso o gestor queira ver mais detalhadamente os lançamentos financeiros que compõe cada valor na tela principal do relatório de Balanço Financeiro
                            ele pode usar as abas superiores para ver o relatório mais detalhado de cada tipo de lançamento. 
                        </p> 

                        <div className="image-wrapper">
                            <img src={BalancoFinanc5} alt="Balanço 5"/>
                        </div>   

                        <p>
                            Dentro da tabela dos lançamentos o gestor ainda tem a opção de liquidar os lançamentos abertos ou abrir os lançamentos já liquidados utilizando
                            oo botões auxiliares dentro da tabela de lançamentos.
                        </p>                                        

                        <div className="image-wrapper">
                            <img src={BalancoFinanc6} alt="Balanço 6"/>
                        </div>   
                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/RelBalancoFinanc.js